export default __webpack_public_path__ + "static/shotshell-home-2x-bb8dd835ba1e49a63869924d3deb270e.png";